import {
  DomainName,
  INumericInputControl,
  TControlName,
  tg,
} from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  FormControlViewModelType,
  LocalizedProps,
  NumericInputFormControlViewModel,
} from '../../view-model/FormControlViewModel';
import { FormSource, FormSourceType } from '../../view-model/FormSource';

import {
  controlDomain,
  getControlValueHistory,
  getValueFromArgsOrConfig,
} from './helpers';

const NUMERIC_CONTROL_DEFAULT_PRECISION = 2;
const NUMERIC_CONTROL_DEFAULT_STEP = 0;

const buildNumericControl = async (
  item: INumericInputControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  source: FormSource,
  domains: Array<{ name: TControlName; domain: DomainName }>
): Promise<NumericInputFormControlViewModel> => {
  const result: NumericInputFormControlViewModel = {
    columns: item.columns,
    noLabel: item.noLabel,
    type: FormControlViewModelType.NUMERIC_INPUT,
    name: item.name,
    value: getValueFromArgsOrConfig<number | null>(item, args, source, null),
    hasValue: true,
    hasHistory: true,
    disabled: item.disabled,
    required: item.required,
    updater: item.updater,
    storeValue: item.storeValue,
    labelWidth: item.labelWidth,
    readonly: item.readonly || source.type === FormSourceType.REVIEW,
    visible: item.visible,
    step: item.step || NUMERIC_CONTROL_DEFAULT_STEP,
    precision: NUMERIC_CONTROL_DEFAULT_PRECISION,
    min: item.min,
    max: item.max,
    initialStepValue: item.initialStepValue,
    history: getControlValueHistory(source, item.name),
    enableButtonOnReadOnly: source.type !== FormSourceType.REVIEW,
    invalid: item.invalid,
    errorMessage: item.errorMessage,
    ...localizedProps,
  };

  if (
    tg.isNothing(item.precision) ||
    tg.isNothing(item.min) ||
    tg.isNothing(item.max)
  ) {
    const domain = await controlDomain(item, source, domains);
    if (domain?.type === 'number') {
      if (tg.isNothing(item.precision)) {
        if (domain.subtype === 'double' && tg.isSomething(domain.precision)) {
          result.precision = domain.precision;
        } else {
          result.precision = 0;
        }
      }
      if (tg.isNothing(item.min)) {
        result.min = domain.min;
      }
      if (tg.isNothing(item.max)) {
        result.max = domain.max;
      }
      if (domain.subtype === 'year') {
        result.withoutThousandSeparator = true;
        if (tg.isNothing(item.initialStepValue)) {
          result.initialStepValue = new Date().getFullYear();
        }
      }
    }
  }

  return result;
};

export default buildNumericControl;
